import { Component, AfterViewInit, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-empty-header',
  templateUrl: './empty-header.component.html',
  styleUrls: ['./empty-header.component.scss']
})
export class EmptyHeaderComponent implements AfterViewInit, AfterViewChecked
{

  @ViewChild('headerContent') headerContent: ElementRef;
  @ViewChild('headerContainer') headerContainer: ElementRef;
  @ViewChild("headerButtonBar") headerButtonBar: ElementRef;

  private prevHeight: number = 0;
  private prevTop: number = 0;

  private offsetHeight: number = 100;
  private offsetTop: number = 35;

  setUI()
  {
    if (window.innerWidth > 600)
    {
      this.prevHeight = (this.headerContent.nativeElement.offsetHeight + this.offsetHeight);
      this.prevTop = (this.headerContent.nativeElement.offsetHeight + this.offsetTop);

      this.headerContainer.nativeElement.style.height = `${ this.prevHeight }px`;
      this.headerButtonBar.nativeElement.style.top = `${ this.prevTop }px`;
    } 
    else
    {
      this.prevHeight = this.headerContent.nativeElement.offsetHeight;
      this.prevTop = 0;

      this.headerContainer.nativeElement.style.height = "auto";
      this.headerButtonBar.nativeElement.style.top = this.prevTop;
    }
  }

  checkElementLocations()
  {
    if (this.prevHeight !== this.headerContainer.nativeElement.style.height ||
      this.prevTop !== this.headerButtonBar.nativeElement.style.top)
    {
      this.setUI();
    }
  }

  ngAfterViewInit()
  {
    this.setUI();
  }

  ngAfterViewChecked()
  {
    this.checkElementLocations();
  }
}
